@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../input-constants.module.less';

.container {
  &.error {
    .input {
      border: solid 1px @input-v2-INTERNAL--error--border-color;
    }

    .label {
      color: @input-v2-INTERNAL--error--text-color;
    }
  }

  &.disabled {
    opacity: 0.5;
  }

  .label {
    font-weight: 400;
    font-size: 12px;

    .additional-info-label {
      font-size: 12px;
      font-weight: 400;
      color: @input-v2-INTERNAL--additional-info-label--text-color;
      padding-left: 4px;
    }
  }

  .input {
    .input-width();
    z-index: 1;
    width: 100%;
    height: 32px;
    transition: all 300ms ease;
    border: solid 1px @input-v2-INTERNAL--border-color;
    font-size: 14px;
    margin-top: 4px;

    &:not(.disabled) {
      &:focus {
        border: solid 1px @input-v2-INTERNAL--hover--border-color;
      }
    }

    &.without-label {
      margin-top: 0;
    }
  }
}
